import { ca } from '@cian/analytics';

export function trackInputInFocused() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'search_string',
    action: 'open',
    label: '',
  });
}
